import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const FN_PARAMS_SCHEMA_LITERAL = {
    title: 'Schéma FnParams',
    description: 'Décrit FnParams',
    version: 9,
    keyCompression: false,
    primaryKey: 'CBMARQ',
    type: 'object',
    properties: {
        CBMARQ: { type: 'string', maxLength : 2 },
        FN_TIMBRE_ENABLED: { type: 'boolean' },
        FN_TIMBRE_PARAMS: { type: 'string' },
        FN_REMISEG_ENABLED: { type: 'boolean' },
        FN_REMISEG_PARAMS: { type: 'string' },
        FN_FOND_CAISSE_ENABLED: { type: 'boolean' },
        FN_FOND_CAISSE_PARAMS: { type: 'string' },
        FN_MVTS_CAISSE_ENABLED: { type: 'boolean' },
        FN_MVTS_CAISSE_PARAMS: { type: 'string' },
        FN_RETOURS_ENABLED: { type: 'boolean' },
        FN_RETOURS_PARAMS: { type: 'string' },
        FN_CARTECADEAUX_ENABLED: { type: 'boolean' },
        FN_CARTECADEAUX_PARAMS: { type: 'string' },
        FN_CASHOPTS_ENABLED: { type: 'boolean' },
        FN_CASHOPTS_PARAMS: { type: 'string' },
        FN_BALANCES_ENABLED: { type: 'boolean' },
        FN_BALANCES_PARAMS: { type: 'string' },
        FN_MODIFPRIX_ENABLED: { type: 'boolean' },
        FN_MODIFPRIX_PARAMS: { type: 'string' },
        FN_QTENEG_ENABLED: { type: 'boolean' },
        FN_QTENEG_PARAMS: { type: 'string' }
    },
    required: [ 'CBMARQ' ]
} as const;

const schemaTyped = toTypedRxJsonSchema(FN_PARAMS_SCHEMA_LITERAL);
export type RxFnParamsDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const FN_PARAMS_SCHEMA: RxJsonSchema<RxFnParamsDocumentType> = FN_PARAMS_SCHEMA_LITERAL;
